const SDK_VERSION = "10.60.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
